

































import {
  defineComponent, reactive, ref, watch,
} from '@vue/composition-api';
import { useMutation } from '@vue/apollo-composable';

import useAuth from '@/useAuth';

import CashflowCategoryWithPaymentAccount from '@/components/CashFlow/CashflowCategoryWithPaymentAccount.vue';
import CommonModalWithPreset from '@/components/CommonModalWithPreset.vue';

import updateCompany from '@/gql/company/updateCompany.gql';

const CommonSelectWithCompanyDriverPayout = defineComponent({
  components: {
    CashflowCategoryWithPaymentAccount,
    CommonModalWithPreset,
  },
  setup(props) {
    const { me } = useAuth();
    const doneModal = ref(null);

    const companyDriverPayout = reactive({
      fee: {
        cashflowCategory: me.company.feePaymentAccount?.cashFlowCategory?.id,
        paymentAccount: me.company.feePaymentAccount?.id,
      },
      driverAllowance: {
        cashflowCategory: me.company.driverAllowancePaymentAccount?.cashFlowCategory?.id,
        paymentAccount: me.company.driverAllowancePaymentAccount?.id,
      },
      fine: {
        cashflowCategory: me.company.finePaymentAccount?.cashFlowCategory?.id,
        paymentAccount: me.company.finePaymentAccount?.id,
      },
      deliverymanFee: {
        cashflowCategory: me.company.deliverymanFeePaymentAccount?.cashFlowCategory?.id,
        paymentAccount: me.company.deliverymanFeePaymentAccount?.id,
      },
      deliverymanDriverAllowance: {
        cashflowCategory: me.company.deliverymanDriverAllowancePaymentAccount?.cashFlowCategory?.id,
        paymentAccount: me.company.deliverymanDriverAllowancePaymentAccount?.id,
      },
      deliverymanFine: {
        cashflowCategory: me.company.deliverymanFinePaymentAccount?.cashFlowCategory?.id,
        paymentAccount: me.company.deliverymanFinePaymentAccount?.id,
      },
    });

    watch(() => me.company.id, () => {
      if (me.company.id !== -1) {
        companyDriverPayout.fee = {
          cashflowCategory: me.company.feePaymentAccount?.cashFlowCategory?.id,
          paymentAccount: me.company.feePaymentAccount?.id,
        };
        companyDriverPayout.driverAllowance = {
          cashflowCategory: me.company.driverAllowancePaymentAccount?.cashFlowCategory?.id,
          paymentAccount: me.company.driverAllowancePaymentAccount?.id,
        };
        companyDriverPayout.fine = {
          cashflowCategory: me.company.finePaymentAccount?.cashFlowCategory?.id,
          paymentAccount: me.company.finePaymentAccount?.id,
        };
        companyDriverPayout.deliverymanFee = {
          cashflowCategory: me.company.deliverymanFeePaymentAccount?.cashFlowCategory?.id,
          paymentAccount: me.company.deliverymanFeePaymentAccount?.id,
        };
        companyDriverPayout.deliverymanDriverAllowance = {
          cashflowCategory: me.company.deliverymanDriverAllowancePaymentAccount?.cashFlowCategory?.id,
          paymentAccount: me.company.deliverymanDriverAllowancePaymentAccount?.id,
        };
        companyDriverPayout.deliverymanFine = {
          cashflowCategory: me.company.deliverymanFinePaymentAccount?.cashFlowCategory?.id,
          paymentAccount: me.company.deliverymanFinePaymentAccount?.id,
        };
      }
    });

    const updateCompanyMutation = useMutation(updateCompany, () => ({
      variables: {
        input: {
          id: me.company.id,
          feePaymentAccount: { connect: companyDriverPayout.fee?.paymentAccount },
          driverAllowancePaymentAccount: { connect: companyDriverPayout.driverAllowance?.paymentAccount },
          finePaymentAccount: { connect: companyDriverPayout.fine?.paymentAccount },
          deliverymanFeePaymentAccount: { connect: companyDriverPayout.deliverymanFee?.paymentAccount },
          deliverymanDriverAllowancePaymentAccount: { connect: companyDriverPayout.deliverymanDriverAllowance?.paymentAccount },
          deliverymanFinePaymentAccount: { connect: companyDriverPayout.deliverymanFine?.paymentAccount },
        },
      },
      refetchQueries: ['me'],
    }));

    updateCompanyMutation.onDone(() => {
      (doneModal.value as any).compose({
        entity: 'ค่าใช้จ่าย',
        action: 'บันทึก',
      });
    });

    return {
      me,

      doneModal,
      companyDriverPayout,
      updateCompanyMutation,
    };
  },
});

export default CommonSelectWithCompanyDriverPayout;
